import { API } from './comunApi'
import { endpointsArticleSearch } from './endpoints'

/**
 * Cliente del motor de búsqueda v2.
 *
 * Todo viaja en la query string y codificado, así que %, /, # y acentos
 * llegan intactos al servidor. El motor antiguo los mete crudos en la ruta
 * y por eso devuelve 400 o 404 antes de llegar al controlador.
 */

const construirQuery = (params) =>
  new URLSearchParams(
    Object.entries(params).filter(
      ([, valor]) => valor !== undefined && valor !== null && valor !== '',
    ),
  ).toString()

export const articleSearchApi = {
  getEngine: () => API.get(endpointsArticleSearch.ENGINE),

  search: (
    { q, scope, page, pageSize, businessUnits, categories } = {},
    cancelToken,
  ) =>
    API.get(
      endpointsArticleSearch.SEARCH(
        construirQuery({ q, scope, page, pageSize, businessUnits, categories }),
      ),
      { cancelToken },
    ),

  /** Artículos de una categoría, resueltos por la tabla N:M. */
  category: (idCategoria, { page, pageSize, businessUnits } = {}, cancelToken) =>
    API.get(
      endpointsArticleSearch.CATEGORY(
        idCategoria,
        construirQuery({ page, pageSize, businessUnits }),
      ),
      { cancelToken },
    ),

  /** Un artículo con sus categorías. */
  article: (idArticulo, cancelToken) =>
    API.get(endpointsArticleSearch.ARTICLE(idArticulo), { cancelToken }),

  /** Hijos directos de una família o subfamília. */
  children: (idPadre, { page, pageSize, businessUnits } = {}, cancelToken) =>
    API.get(
      endpointsArticleSearch.CHILDREN(
        idPadre,
        construirQuery({ page, pageSize, businessUnits }),
      ),
      { cancelToken },
    ),

  compare: ({ q, scope, businessUnits, categories } = {}, cancelToken) =>
    API.get(
      endpointsArticleSearch.COMPARE(
        construirQuery({ q, scope, businessUnits, categories }),
      ),
      { cancelToken },
    ),
}

export default articleSearchApi
